import { render, staticRenderFns } from "./pdfVue.vue?vue&type=template&id=31a838e0&scoped=true&"
import script from "./pdfVue.vue?vue&type=script&lang=js&"
export * from "./pdfVue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a838e0",
  null
  
)

export default component.exports